interface Props {
  score: number;
  rating: string;
  levelNumber: number;
  levelTitle: string;
  found: number;
  total: number;
  falseAlarms: number;
}

/**
 * The player's badge, in the same design as the LinkedIn share card.
 *
 * Rendered in the browser rather than fetched as an image so it can show this
 * player's actual score. The card LinkedIn scrapes is still the static one --
 * matching that per result needs server-side image generation, which is
 * deliberately deferred. Keeping the two visually identical means switching to
 * generated images later changes nothing the player sees here.
 *
 * Sized entirely in container query units, so the whole badge scales as one
 * piece from a 375px phone up to desktop without a single breakpoint.
 */
export function ResultBadge({
  score,
  rating,
  levelNumber,
  levelTitle,
  found,
  total,
  falseAlarms,
}: Props) {
  return (
    <div className="badge-wrap">
      <div className="badge">
        <div className="badge__brand">DevTool Detective</div>

        <div className="badge__score-row">
          <span className="badge__score">{score}</span>
          <span className="badge__outof">/100</span>
        </div>

        <div className="badge__rating">{rating}</div>

        <div className="badge__rule" />
        <div className="badge__level">
          Level {levelNumber} · {levelTitle}
        </div>
        <div className="badge__stats">
          {found} of {total} found · {falseAlarms} false alarm
          {falseAlarms === 1 ? '' : 's'}
        </div>

        {/*
          Shaft plus two barbs struck from the same tip, rather than a shaft and
          a separate filled triangle. The triangle had to be positioned to meet
          the shaft exactly and did not, which is what produced the blob. Barbs
          share the tip coordinate, so they cannot drift apart, and the barbs
          sit at a symmetric 32 degrees either side of the shaft.
        */}
        <svg
          className="badge__arrow"
          viewBox="0 0 100 100"
          aria-hidden="true"
          focusable="false"
        >
          <g
            stroke="#e8503a"
            strokeWidth="12"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          >
            <path d="M86 16 L34 68" />
            <path d="M34 68 L64 61" />
            <path d="M34 68 L41 38" />
          </g>
        </svg>
      </div>
    </div>
  );
}
